import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

// Forge is the locked-in default theme; comfy is the locked-in density.
document.documentElement.setAttribute("data-theme", "forge");
document.body.setAttribute("data-theme", "forge");
document.body.setAttribute("data-density", "comfy");

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
